import { DECLINE_REASONS } from '@lib/prescriptions/data-access';

/**
 * Why cover is granted.
 *
 * Its own list, never the refusals and never the amendment vocabulary the edit and delete flows use:
 * the three name three different acts. A refusal states why the contract does not answer for the
 * service; an amendment states why the line changed; a grant states why the insurer is committing.
 *
 * Written as the positive side of the same contract the refusals are drawn from — each ground here
 * answers one of the axes {@link DECLINE_REASONS} refuses on, so the two read as one policy stated
 * both ways. V1 carries no vocabulary here to draw on: its only grant wording marks a line the rule
 * engine guaranteed by itself, which V2 records as the decision's authority rather than as grounds a
 * health manager gave.
 */
export const GUARANTEE_REASONS: string[] = [
  'Страховий випадок згідно з умовами договору.',
  'Діагноз входить до переліку страхових ризиків.',
  'Послуга передбачена Переліком медичних послуг та медикаментів страхових захворювань.',
  'Медикамент передбачений Переліком медичних послуг та медикаментів страхових захворювань.',
  'Метод лікування погоджений Асистуючою компанією.',
  'Медикаментозне забезпечення погоджене Асистуючою компанією.',
  'Діагностика, необхідна для встановлення клінічного діагнозу в межах страхового випадку.',
  'Невідкладна допомога за життєвими показаннями.',
  'Лікування ускладнення страхового випадку.',
  'Продовження лікування в межах узгодженого страхового випадку.',
  'Призначення персонального лікаря в межах страхового випадку.',
  'Послуга надана в межах ліміту, передбаченого договором.',
  'Погоджено в індивідуальному порядку зі страховиком.',
  'Інші підстави для гарантування, передбачені договором.',
];

/**
 * Why cover is refused. V1's curated list, re-exported rather than copied — it is the same policy,
 * and a second copy would drift the moment either side was edited.
 */
export { DECLINE_REASONS };
